export default __webpack_public_path__ + "static/media/edit-target-amount.b32c3650.svg";